/*
 * Shared HSOC user-limit constants. Imported by both the merch-card subtext
 * (HsocMerchCardSubtext) and the feature-table plan-details user-limits row
 * (buildPlanDetailsGroup) so the "Up to N / Unlimited users" rule stays in one
 * place and can't drift between the cards and the table.
 */

/* The FREE tier is capped at 2 users (business rule). */
export const FREE_TIER_MAX_USERS = 2;

/* The backend returns Integer.MAX_VALUE as the touchless cap for a tier with no
 * user limit (Professional/Enterprise) — i.e. unlimited users. */
export const UNLIMITED_TOUCHLESS_QUANTITY = 2 ** 31 - 1;